import React from "react";
import { Container } from "react-bootstrap";
import ProfileCard from "../../components/ProfileCard/ProfileCard";
import MyBookings from "../../components/MyBookings/MyBookings";
import useQueryResponse from "../../lib/hooks/useQueryResponse";
import getAllBooking from "./getAllBooking.graphql";

const BookingContainer = ({ preferredCurrency, type }) => {

    const { data, loading, refetch } = useQueryResponse({
        query: getAllBooking,
        variables: {
            currentPage: 1,
            requestType: type,
            requestCurrency: preferredCurrency
        },
        fetchPolicy: 'network-only',
        ssr: false

    })
    return (
        <div className={'subPageContainer'}>
            <Container>
                <div className='subPageWrapper'>
                    <ProfileCard />
                    <MyBookings type={type} loading={loading} data={data?.getAllBooking} refetch={refetch} />
                </div>
            </Container>
        </div>
    )
}
export default BookingContainer